export default function chunkArray<T>(array: T[] | undefined, size: number = 4): T[][] {
    if (!array) {
        return [];
    }

    const result: T[][] = [];

    for (let i = 0; i < array.length; i += size) {
        result.push(array.slice(i, i + size));
    }

    return result;
}
